import React from 'react';
import { Formik, Form } from 'formik';
import { Button, Divider } from 'antd';
import PropTypes from 'prop-types';
import { InputFromUser } from '../Input/input';
import { appointmentDetailsValidationSchema } from '../../utils/FormValidation';

const AppointmentDetailsForm = ({
  AdminUser,
  AllConsultation,
  DrSlotAvailability,
  DrAvailability,
  disabledDate,
  fetchDoctorAvailability,
  fetchSlotAvailability,
  onSubmit,
}) => {
  return (
    <Formik
      initialValues={{
        casePaperNo: '23_12_2023',
        consultationType: '',
        selectYourDoctor: '',
        consultingFor: '',
        Time: '',
        appointmentDate: '',
        amount: '',
      }}
      validationSchema={appointmentDetailsValidationSchema}
      onSubmit={onSubmit}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => {
        const drId = AdminUser?.[0]?.filter(doctor => doctor.name === values.selectYourDoctor)?.[0]
          ?._id;

        return (
          <Form>
            <div className="row">
              <div className="my-4">
                <Divider style={{ fontWeight: '600' }}>Appointment Details</Divider>
              </div>
              <InputFromUser
                type={'radio'}
                label={'Consultation Type'}
                options={[
                  { label: 'Tele-Consultation', value: 'Tele-Consultation' },
                  { label: 'In-Person', value: 'IN-Person' },
                ]}
                FormGroupClassName={'col-xl-6 col-md-12'}
                LabelClassName={'col-form-label'}
                onBlur={() =>
                  handleBlur({
                    target: {
                      name: 'consultationType',
                      value: true,
                    },
                  })
                }
                onChange={v => {
                  const DrId = AdminUser?.[0]?.filter(
                    doctor => doctor.name === values?.selectYourDoctor
                  )?.[0]?._id;
                  if (DrId) {
                    fetchDoctorAvailability(DrId, v);
                  }
                  handleChange({
                    target: {
                      name: 'consultationType',
                      value: v,
                    },
                  });
                  if (
                    typeof values.appointmentDate === 'object' &&
                    values?.consultingFor.length !== 0
                  ) {
                    fetchSlotAvailability(
                      drId,
                      values.consultationType,
                      values.appointmentDate,
                      values?.consultingFor
                    );
                  }
                }}
                error={errors.consultationType}
                selectedValue={values.consultationType}
                touched={touched.consultationType}
              />

              <InputFromUser
                label="Select Your Doctor"
                Showlabel={true}
                mode={''}
                type={'singleSelect'}
                name="selectYourDoctor"
                disabled={values?.consultationType.length === 0}
                onChange={v => {
                  const DrId = AdminUser?.[0]?.filter(doctor => doctor.name === v)?.[0]?._id;
                  setFieldValue('selectYourDoctor', v, true);
                  fetchDoctorAvailability(DrId, values.consultationType);
                  if (
                    typeof values.appointmentDate === 'object' &&
                    values?.consultingFor.length !== 0
                  ) {
                    fetchSlotAvailability(
                      DrId,
                      values.consultationType,
                      values.appointmentDate,
                      values?.consultingFor
                    );
                  }
                }}
                FormControlClassName={'form-control'}
                FormGroupClassName={'col-xl-6 col-md-12'}
                LabelClassName={'col-form-label'}
                value={values?.selectYourDoctor}
                onBlur={() => {
                  setFieldTouched('selectYourDoctor', true, true);
                }}
                error={errors?.selectYourDoctor}
                touched={touched?.selectYourDoctor}
                onSearchLoading={false}
                options={AdminUser?.[0] ? AdminUser?.[0]?.map(v => v.name) : []}
                placeholder={'Select Your Doctor'}
              />

              <InputFromUser
                label="Consulting for"
                type="singleSelect"
                Showlabel={true}
                mode={''}
                name="consultingFor"
                onChange={v => {
                  setFieldValue('consultingFor', v, true);
                  setFieldValue(
                    'amount',
                    AllConsultation?.[0]?.filter(
                      val => val.consultationType === values.consultingFor
                    )?.[0]?.price,
                    true
                  );
                  if (
                    typeof values.appointmentDate === 'object' &&
                    values?.consultingFor.length !== 0
                  ) {
                    fetchSlotAvailability(
                      drId,
                      values.consultationType,
                      values.appointmentDate,
                      values?.consultingFor
                    );
                  }
                }}
                FormControlClassName={'form-control'}
                FormGroupClassName={'col-xl-6 col-md-12'}
                LabelClassName={'col-form-label'}
                value={values?.consultingFor}
                onBlur={() => {
                  setFieldTouched('consultingFor', true, true);
                }}
                error={errors?.consultingFor}
                touched={touched?.consultingFor}
                onSearchLoading={false}
                options={
                  AllConsultation?.[0] ? AllConsultation?.[0]?.map(v => v.consultationType) : []
                }
                placeholder={'Select Consulting For'}
              />
              <InputFromUser
                label="Date of Appointment"
                type="date"
                Showlabel={true}
                disabledDate={disabledDate}
                disabled={
                  typeof DrAvailability?.[0]?.disabledDates === 'object'
                    ? DrAvailability?.[0]?.disabledDates?.length === 0
                    : true
                }
                name="appointmentDate"
                onChange={v => {
                  setFieldValue('appointmentDate', v, true);
                  if (
                    typeof values.appointmentDate === 'object' &&
                    values?.consultingFor.length !== 0
                  ) {
                    fetchSlotAvailability(
                      drId,
                      values.consultationType,
                      values.appointmentDate,
                      values?.consultingFor
                    );
                  }
                }}
                FormControlClassName={'form-control'}
                FormGroupClassName={'col-xl-6 col-md-12'}
                LabelClassName={'col-form-label'}
                value={values?.appointmentDate}
                onBlur={() => {
                  setFieldTouched('appointmentDate', true, true);
                }}
                error={errors?.appointmentDate}
                touched={touched?.appointmentDate}
                onSearchLoading={false}
                placeholder={
                  (
                    typeof DrAvailability?.[0]?.disabledDates === 'object'
                      ? DrAvailability?.[0]?.disabledDates?.length === 0
                      : true
                  )
                    ? values.consultationType === 'Tele-Consultation'
                      ? 'Doctor is Not available for Tele-Consultation consultation!!'
                      : 'Doctor is Not available for IN-Person consultation!!'
                    : 'Select Date of Appointment'
                }
              />
              <InputFromUser
                label="Time Slot"
                Showlabel={true}
                mode={''}
                disabled={
                  !(
                    typeof values.appointmentDate === 'object' &&
                    !(values?.consultingFor.length === 0) &&
                    !(Array.isArray(DrSlotAvailability) ? DrSlotAvailability.length === 0 : true)
                  )
                }
                type={'singleSelect'}
                name="appointmentDate"
                onChange={v => {
                  setFieldValue('Time', v, true);
                }}
                FormControlClassName={'form-control'}
                FormGroupClassName={'col-xl-6 col-md-12'}
                LabelClassName={'col-form-label'}
                value={values?.Time}
                options={
                  Array.isArray(DrSlotAvailability)
                    ? DrSlotAvailability?.filter(slot => !slot?.isBooked)?.map(
                      slot => slot?.startTime
                    )
                    : []
                }
                onBlur={() => {
                  setFieldTouched('Time', true, true);
                }}
                error={errors?.Time}
                touched={touched?.Time}
                onSearchLoading={false}
                placeholder={'Select Consulting For'}
              />

              <InputFromUser
                type="text"
                Showlabel={true}
                label="Amount"
                FormControlClassName={'form-control'}
                FormGroupClassName={'col-xl-6 col-md-12'}
                LabelClassName={'col-form-label'}
                name="amount"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.amount}
                value={values.amount}
                disabled={true}
                touched={touched.amount}
                placeholder={''}
              />

              <div className="col-12">
                <div className="text-end">
                  <Button
                    onClick={() => {
                      handleSubmit();
                    }}
                    type="primary"
                    disabled={isSubmitting}
                    className="pb-4"
                  >
                    Pay
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

AppointmentDetailsForm.propTypes = {
  AdminUser: PropTypes.array,
  AllConsultation: PropTypes.array,
  DrSlotAvailability: PropTypes.array,
  DrAvailability: PropTypes.array,
  disabledDate: PropTypes.func.isRequired,
  fetchDoctorAvailability: PropTypes.func.isRequired,
  fetchSlotAvailability: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default React.memo(AppointmentDetailsForm);
